module.exports = " <div class=item> <slot></slot> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider.vue
 ** module id = 609
 ** module chunks = 2
 **/